module.exports = __webpack_public_path__ + "static/media/hover-popup.e8e3a477.svg";